import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _focused, _cleanup, _setup;
import "core-js/modules/esnext.global-this.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
// src/focusManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var FocusManager = (_focused = /*#__PURE__*/new WeakMap(), _cleanup = /*#__PURE__*/new WeakMap(), _setup = /*#__PURE__*/new WeakMap(), class FocusManager extends Subscribable {
  constructor() {
    super();
    _classPrivateFieldInitSpec(this, _focused, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _cleanup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _setup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _setup, onFocus => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!_classPrivateFieldGet(this, _cleanup)) {
      this.setEventListener(_classPrivateFieldGet(this, _setup));
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldGet2;
      (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _cleanup)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.call(this);
      _classPrivateFieldSet(this, _cleanup, void 0);
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldGet3;
    _classPrivateFieldSet(this, _setup, setup);
    (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _cleanup)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
    _classPrivateFieldSet(this, _cleanup, setup(focused => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    }));
  }
  setFocused(focused) {
    const changed = _classPrivateFieldGet(this, _focused) !== focused;
    if (changed) {
      _classPrivateFieldSet(this, _focused, focused);
      this.onFocus();
    }
  }
  onFocus() {
    const isFocused = this.isFocused();
    this.listeners.forEach(listener => {
      listener(isFocused);
    });
  }
  isFocused() {
    var _globalThis$document;
    if (typeof _classPrivateFieldGet(this, _focused) === "boolean") {
      return _classPrivateFieldGet(this, _focused);
    }
    return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
  }
});
var focusManager = new FocusManager();
export { FocusManager, focusManager };